/**
 * Created by laugh on 9/21/2017.
 */
import {combineReducers} from 'redux';
import OfferResponse from './offer-response';
import SelectedOffer from './selected-offer';
import CmsConfig from './cms-configuration';
import InitParams from './init-params';
import SetCustomer from './set-customer';
import OrderConfirmation from './order-confirmation';
import OrderData from './order-data';

/*
 * We combine all reducers into a single object before updated data is dispatched (sent) to store
 * Your entire applications state (store) is just whatever gets returned from all your reducers
 * */

const allReducers = combineReducers({
    offers: OfferResponse,
    selectedOffer: SelectedOffer,
    initParams: InitParams,
    setCustomer: SetCustomer,
    cmsConfig: CmsConfig,
    orderConfirmation: OrderConfirmation,
    orderData: OrderData
});

export default allReducers


// WEBPACK FOOTER //
// ./src/reducers/index.js